<div class="flex flex-col gap-y-4">
	<app-soluno-accounting-items-table
		class="col-span-2"
		title="Legal fees"
		[hst]="hst$ | async"
		[hstTotal]="(totals$ | async)?.feesHST"
		[items]="solunoConvenyancingFeeItems$ | async"
	></app-soluno-accounting-items-table>
	<app-soluno-accounting-items-table
		class="col-span-2"
		title="HST disbursements"
		activityCodeColumnTitle="Activity Code & G/L Account"
		[hst]="hst$ | async"
		[hstTotal]="(totals$ | async)?.HSTDisbursementsHST"
		[items]="solunoHstItems$ | async"
	></app-soluno-accounting-items-table>
	<app-soluno-accounting-items-table
		class="col-span-2"
		title="Non HST disbursements"
		activityCodeColumnTitle="Activity Code & G/L Account"
		[items]="solunoNonHstItems$ | async"
	></app-soluno-accounting-items-table>
</div>
